import type { ReactNode } from "react";

// Labelled input wrapper for admin modal forms. The user app inlines
// its field markup; admin has many forms (grant credits, ban reason,
// rate-limit override, plan edit, impersonate TTL) so a primitive
// earns its keep here.
export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <label className="block mb-3">
      <span className="block font-mono text-[10px] uppercase tracking-widest text-ink-400 mb-1">
        {label}
      </span>
      {children}
      {hint && <span className="block text-[11px] text-ink-400 mt-1">{hint}</span>}
    </label>
  );
}

// Convenience styled <input>. Callers may use a raw <input> when more
// control is needed.
export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={`w-full bg-ink-950 border border-ink-700 rounded px-2 py-1.5 text-sm text-ink-100 focus:border-accent focus:outline-none ${props.className ?? ""}`}
    />
  );
}

// Convenience styled <textarea>.
export function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      className={`w-full bg-ink-950 border border-ink-700 rounded px-2 py-1.5 text-sm text-ink-100 focus:border-accent focus:outline-none ${props.className ?? ""}`}
    />
  );
}
